import React from 'react'
import { Bling as Slider } from 'react-gpt'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

const removeEmpty = event => {
  if (event.isEmpty) {
    var list
    list = document.querySelectorAll('.bx-banner-travel')
    for (var i = 0; i < list.length; ++i) {
      list[i].classList.add('d-none')
    }
  }
}
const configureDfpTargeting = (dfpAccount, sliders, campaignId, catalogId, clientId) =>
  sliders.map(slider => ({
    accountDfp: dfpAccount,
    sliderName: slider,
    urlSlider: '/' + dfpAccount + '/' + slider,
    sizeMapping: [
      { viewport: [0, 0], slot: [335, 160] },
      { viewport: [475, 0], slot: [1180, 300] }
    ],
    targeting: {
      ltm_campaign: [campaignId, 'default'],
      ltm_catalog: [catalogId, 'default'],
      vertem_template: [process.env.REACT_APP_HAS_BANNER_TEMPLATE || 'default'],
      ltm_costumer: [clientId]
    }
  }))

const ConexxeBannerDFP = ({ profile, google }) => {
  const sliders = [
    'ragnarok_travel'
  ]
  const campaignId = profile ? profile['custom:campaign_id'] : '0'
  const catalogId = profile ? profile['custom:catalog_id'] : process.env.REACT_APP_CATALOG_ID
  const clientId = profile ? profile['custom:client_id'] : '0'

  const sliderList = configureDfpTargeting(google.accountDfp, sliders, campaignId, catalogId, clientId)

  return (
    <div className='bx-banner-travel pos-relative pb-2'>
      <div className='container px-0'>
        <div className='row mx-0'>
          {sliderList.map((itemSlider, index) => (
            <div key={index} className='col-12 px-1 px-sm-0 txt-center'>
              <Slider
                adUnitPath={itemSlider.urlSlider}
                targeting={itemSlider.targeting}
                sizeMapping={
                  itemSlider.sizeMapping
                }
                onSlotRenderEnded={removeEmpty}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

ConexxeBannerDFP.propTypes = {
  profile: PropTypes.shape({
    'custom:campaign_id': PropTypes.string.isRequired,
    'custom:catalog_id': PropTypes.string.isRequired,
    'custom:client_id': PropTypes.string.isRequired
  }),
  google: PropTypes.shape({
    accountDfp: PropTypes.string.isRequired
  })
}

const mapStateToProps = ({ oidc: { user }, google }) => ({
  profile: user && user.profile,
  google
})

export default connect(mapStateToProps)(ConexxeBannerDFP)



// WEBPACK FOOTER //
// ./src/features/Slider/ConexxeBannerDFP.js